import classNames from 'classnames';

import { Typography } from '@/shared/components/atoms/Typography';
import { IVerticalStepsProps } from '@/shared/components/atoms/VerticalSteps/IVerticalSteps';

import Arrow from '~/images/shared/arrows/arrow-up.svg';

const VerticalSteps: React.FC<IVerticalStepsProps> = ({ steps, stepIndex }) => {
  return (
    <div className='flex items-stretch gap-24'>
      <div className='w-8 rounded-[10px] bg-neutralVariant-90'>
        <div
          className='w-full rounded-[10px] bg-secondary-20'
          style={{
            height: `${((stepIndex + 1) / steps.length) * 100}%`,
          }}
        />
      </div>
      <div className='flex flex-grow flex-col justify-between gap-32 py-8'>
        {steps.map((step, idx) => (
          <Typography
            variant='subtitle'
            className={classNames(
              'flex items-center justify-between whitespace-nowrap',
              step?.clickable && 'cursor-pointer'
            )}
            onClick={() => {
              if (step.clickable && step.onClick) step.onClick(idx);
            }}
            weight={idx === stepIndex ? 'bold' : undefined}
            key={step.title}
          >
            {step.title}
            {step.clickable && (
              <span className='text-primary-default ltr:rotate-90 rtl:-rotate-90 tablet:hidden'>
                <Arrow />
              </span>
            )}
          </Typography>
        ))}
      </div>
    </div>
  );
};

export default VerticalSteps;
